import React, { useEffect, useState } from "react";
import CursosHorariosPanel from "./CursosHorariosPanel";
import ProductoBuscador from "../../../seguridad/contifico/ProductoBuscador";
import { listarProductosContifico } from "../../../../services/contificoService";

const ModalWrapper = ({ open, title, children, onClose, size = "modal-lg" }) => {
    if (!open) return null;
    return (
        <div
            className="modal fade show d-block management-modal"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
            style={{ backgroundColor: "rgba(15, 23, 42, 0.45)" }}
        >
            <div className={`modal-dialog ${size} modal-dialog-centered`} role="document">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} />
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
};

const renderOptions = (items, loading, label) => {
    if (loading) return <option value="">Cargando {label}...</option>;
    if (!items.length) return <option value="">{`No hay ${label}`}</option>;
    return [
        <option key="placeholder" value="">
            Selecciona {label}
        </option>,
        ...items.map((item) => (
            <option key={item.id} value={item.id}>
                {item.nombre}
            </option>
        )),
    ];
};

export default function CursosFormModal({
    modal,
    formNuevo,
    setFormNuevo,
    formEditar,
    setFormEditar,
    cursoEditando,
    saving,
    deleting,
    detalleLoading,
    cerrarModal,
    handleCrear,
    handleActualizar,
    handleEliminar,
    horarios,
    centros = [],
    niveles = [],
    especialidades = [],
    cursosOficialesOptions = [],
    loadingOptions = false,
    canCreate = true,
    canUpdate = true,
    canDelete = true,
}) {
    const [activeTab, setActiveTab] = useState("info");
    const [productosContifico, setProductosContifico] = useState([]);

    useEffect(() => {
        if (modal) setActiveTab("info");
    }, [modal]);

    useEffect(() => {
        listarProductosContifico()
            .then(data => setProductosContifico((data || []).filter(p => p.activo)))
            .catch(() => {});
    }, []);

    const tabsCrear = [
        { key: "info", label: "Informacion" },
        { key: "horarios", label: "Horarios" },
    ];

    const tabsEditar = [
        { key: "info", label: "Informacion" },
        { key: "horarios", label: "Horarios" },
    ];

    const renderTabs = (isEdit) => (
        <ul className="nav nav-tabs mb-3">
            {(isEdit ? tabsEditar : tabsCrear).map((tab) => {
                const isHorarios = tab.key === "horarios";
                const horariosDisabled = isHorarios && (!isEdit || !cursoEditando?.id);
                const label = horariosDisabled ? (
                    <>
                        <i className="bi bi-lock-fill me-1" />
                        {tab.label}
                    </>
                ) : (
                    tab.label
                );
                const button = (
                    <button
                        type="button"
                        className={`nav-link ${activeTab === tab.key ? "active" : ""} ${horariosDisabled ? "disabled" : ""}`}
                        onClick={() => setActiveTab(tab.key)}
                        disabled={horariosDisabled}
                        aria-disabled={horariosDisabled}
                    >
                        {label}
                    </button>
                );
                return (
                    <li className="nav-item" key={tab.key}>
                        {horariosDisabled ? (
                            <span className="d-inline-block" title="Primero guarda los datos del curso">
                                {button}
                            </span>
                        ) : (
                            button
                        )}
                    </li>
                );
            })}
        </ul>
    );

    const renderForm = (form, setForm, onSubmit, submitLabel, disabled, mode) => {
        const isEdit = mode === "editar";
        const precioBaseValue = Number(form.precio_base ?? 0);
        const ivaRate = Number(form.iva_porcentaje ?? 15) / 100;
        const totalConIva = precioBaseValue > 0 ? precioBaseValue * (1 + ivaRate) : 0;
        return (
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    onSubmit?.();
                }}
            >
                <div className="modal-body pt-0">
                    <div className="mb-2">
                        <p className="text-muted mb-1">Configura los detalles del curso</p>
                    </div>
                    {renderTabs(isEdit)}
                    {activeTab === "info" && (
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label management-label">Nombre *</label>
                                <input
                                    className="form-control"
                                    value={form.nombre || ""}
                                    onChange={(e) => setForm((prev) => ({ ...prev, nombre: e.target.value }))}
                                    required
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label management-label">Centro</label>
                                <select
                                    className="form-select"
                                    value={form.centro_id || ""}
                                    onChange={(e) => setForm((prev) => ({ ...prev, centro_id: e.target.value }))}
                                    disabled={loadingOptions}
                                >
                                    {renderOptions(centros, loadingOptions, "un centro")}
                                </select>
                            </div>

                            <div className="col-md-4">
                                <label className="form-label management-label">Codigo del curso *</label>
                                <input
                                    className="form-control"
                                    value={form.codigo_curso || ""}
                                    onChange={(e) =>
                                        setForm((prev) => ({
                                            ...prev,
                                            codigo_curso: e.target.value.toUpperCase(),
                                        }))
                                    }
                                    placeholder="Ej. MF"
                                    maxLength={20}
                                    required
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label management-label">Nivel</label>
                                <select
                                    className="form-select"
                                    value={form.nivel_id || ""}
                                    onChange={(e) => setForm((prev) => ({ ...prev, nivel_id: e.target.value }))}
                                    disabled={loadingOptions}
                                >
                                    {renderOptions(niveles, loadingOptions, "un nivel")}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label management-label">Especialidad</label>
                                <select
                                    className="form-select"
                                    value={form.especialidad_id || ""}
                                    onChange={(e) => setForm((prev) => ({ ...prev, especialidad_id: e.target.value }))}
                                    disabled={loadingOptions}
                                >
                                    {renderOptions(especialidades, loadingOptions, "una especialidad")}
                                </select>
                            </div>

                            <div className="col-md-2">
                                <label className="form-label fw-semibold">Duracion (horas)</label>
                                <input
                                    type="number"
                                    min="1"
                                    step="1"
                                    className="form-control"
                                    value={form.duracion_horas ?? ""}
                                    onChange={(e) => setForm((prev) => ({ ...prev, duracion_horas: e.target.value }))}
                                />
                            </div>
                            <div className="col-md-2">
                                <label className="form-label management-label">Precio base (sin IVA)</label>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    className="form-control"
                                    value={form.precio_base ?? ""}
                                    onChange={(e) => setForm((prev) => ({ ...prev, precio_base: e.target.value }))}
                                />
                            </div>
                            <div className="col-md-2">
                                <label className="form-label management-label">IVA</label>
                                <select
                                    className="form-select"
                                    value={form.iva_porcentaje ?? 15}
                                    onChange={(e) => setForm((prev) => ({ ...prev, iva_porcentaje: Number(e.target.value) }))}
                                >
                                    <option value={0}>0%</option>
                                    <option value={15}>15%</option>
                                </select>
                            </div>
                            <div className="col-md-2">
                                <label className="form-label management-label">
                                    Total con IVA ({form.iva_porcentaje ?? 15}%)
                                </label>
                                <input
                                    type="text"
                                    className="form-control bg-light"
                                    value={totalConIva ? totalConIva.toFixed(2) : ""}
                                    readOnly
                                />
                            </div>
                            <div className="col-md-2">
                                <label className="form-label fw-semibold">Monto min. reserva</label>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    className="form-control"
                                    placeholder="Ej. 50.00"
                                    value={form.monto_min_reserva ?? ""}
                                    onChange={(e) => setForm((prev) => ({ ...prev, monto_min_reserva: e.target.value }))}
                                />
                            </div>
                            <div className="col-md-2">
                                <label className="form-label fw-semibold">Monto matricula</label>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    className="form-control"
                                    placeholder="Ej. 125.00"
                                    value={form.monto_matricula ?? ""}
                                    onChange={(e) => setForm((prev) => ({ ...prev, monto_matricula: e.target.value }))}
                                />
                            </div>

                            <ProductoBuscador
                                productos={productosContifico}
                                value={form.contifico_codigo || ''}
                                onChange={({ contifico_codigo, contifico_producto_id }) =>
                                    setForm(prev => ({ ...prev, contifico_codigo, contifico_producto_id }))
                                }
                                label="Producto Contífico"
                                helpText="Producto en Contífico que se facturará al pagar este curso."
                            />
                            <div className="col-md-6">
                                <label className="form-label management-label">Comisión por referido ($)</label>
                                <div className="input-group">
                                    <span className="input-group-text">$</span>
                                    <input
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        className="form-control"
                                        placeholder="Global"
                                        value={form.monto_comision ?? ""}
                                        onChange={(e) => setForm(prev => ({ ...prev, monto_comision: e.target.value }))}
                                    />
                                </div>
                                <div className="form-text">Vacío = usa el monto global configurado.</div>
                            </div>

                            <div className="col-md-6 d-flex flex-column gap-2 justify-content-center">
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`curso-activo-${mode}`}
                                        checked={!!form.activo}
                                        onChange={(e) => setForm((prev) => ({ ...prev, activo: e.target.checked }))}
                                    />
                                    <label className="form-check-label" htmlFor={`curso-activo-${mode}`}>
                                        {form.activo ? "Activo" : "Inactivo"}
                                    </label>
                                </div>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`es-reentrenamiento-${mode}`}
                                        checked={!!form.es_reentrenamiento}
                                        onChange={(e) => setForm((prev) => ({ ...prev, es_reentrenamiento: e.target.checked }))}
                                    />
                                    <label className="form-check-label" htmlFor={`es-reentrenamiento-${mode}`}>
                                        {form.es_reentrenamiento ? "Reentrenamiento" : "Curso (no reentrenamiento)"}
                                    </label>
                                </div>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`requiere-examen-${mode}`}
                                        checked={!!form.requiere_examen}
                                        onChange={(e) => setForm((prev) => ({ ...prev, requiere_examen: e.target.checked }))}
                                    />
                                    <label className="form-check-label" htmlFor={`requiere-examen-${mode}`}>
                                        {form.requiere_examen
                                            ? "Exige examen de acreditacion (Ministerio)"
                                            : "Se acredita solo con nota de curso"}
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label management-label">
                                    ¿Es variante comercial de otro curso?
                                </label>
                                <select
                                    className="form-select"
                                    value={form.curso_oficial_id || ""}
                                    onChange={(e) => setForm((prev) => ({ ...prev, curso_oficial_id: e.target.value }))}
                                    disabled={loadingOptions}
                                >
                                    <option value="">No, es un curso independiente</option>
                                    {cursosOficialesOptions
                                        .filter((c) => String(c.id) !== String(isEdit ? cursoEditando?.id : ""))
                                        .map((c) => (
                                            <option key={c.id} value={c.id}>
                                                {c.nombre}
                                            </option>
                                        ))}
                                </select>
                                <div className="form-text">
                                    Ej. "Reentrenamiento N1" es variante comercial del curso oficial "Reentrenamiento" (el que reconoce el Ministerio). Su precio, certificado y facturación se resuelven aparte; nunca se usa para crear promociones propias.
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === "horarios" && isEdit && cursoEditando?.id && (
                        <CursosHorariosPanel
                            horarios={horarios?.horarios || []}
                            loading={horarios?.loading}
                            saving={horarios?.saving}
                            deleting={horarios?.deleting}
                            error={horarios?.error}
                            onCrear={horarios?.crearHorario}
                            onActualizar={horarios?.actualizarHorario}
                            onEliminar={horarios?.eliminarHorario}
                        />
                    )}
                </div>

                {activeTab !== "horarios" && (
                    <div className="modal-footer border-0 pt-0">
                        <button type="button" className="btn btn-outline-secondary" onClick={cerrarModal}>
                            Cancelar
                        </button>
                        <button type="submit" className="btn management-btn-primary" disabled={saving || disabled}>
                            {saving ? "Guardando..." : submitLabel}
                        </button>
                    </div>
                )}
            </form>
        );
    };

    return (
        <>
            <ModalWrapper open={modal === "crear"} title="Nuevo curso" onClose={cerrarModal}>
                {renderForm(formNuevo, setFormNuevo, handleCrear, "Guardar curso", !canCreate, "crear")}
            </ModalWrapper>

            <ModalWrapper
                open={modal === "editar"}
                title={cursoEditando ? `Editar: ${cursoEditando.nombre}` : "Editar curso"}
                onClose={cerrarModal}
            >
                {detalleLoading ? (
                    <div className="modal-body text-center py-5">
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                ) : (
                    renderForm(formEditar, setFormEditar, handleActualizar, "Guardar cambios", !canUpdate, "editar")
                )}
            </ModalWrapper>

            <ModalWrapper open={modal === "eliminar"} title="Eliminar curso" onClose={cerrarModal} size="modal-md">
                <div className="modal-body pt-0">
                    <p className="mb-2">
                        Estas a punto de eliminar el curso <strong>{cursoEditando?.nombre || "seleccionado"}</strong>.
                    </p>
                    <p className="text-muted mb-0">Esta accion lo desactivara del catalogo.</p>
                </div>
                <div className="modal-footer border-0 pt-0">
                    <button type="button" className="btn btn-outline-secondary" onClick={cerrarModal} disabled={deleting}>
                        Cancelar
                    </button>
                    <button type="button" className="btn btn-danger" onClick={handleEliminar} disabled={deleting || !canDelete}>
                        {deleting ? "Eliminando..." : "Eliminar"}
                    </button>
                </div>
            </ModalWrapper>
        </>
    );
}
